export const POSITION_ATTRIBUTE_ENUM: {
	values: string[];
	default: string;
} = {
	values: [
		'top left',
		'top center',
		'top right',
		'right top',
		'right middle',
		'right bottom',
		'bottom left',
		'bottom center',
		'bottom right',
		'left top',
		'left middle',
		'left bottom',
	],
	default: 'right middle',
};
